import {Pipe, PipeTransform} from '@angular/core';
import {IPhoneNumber} from '../../interfaces/phone-number/phone-number.interface';
import {Logger} from '../../class/helper/logger.class';

@Pipe({
  name: 'getPhoneStructure'
})
export class GetPhoneStructurePipe implements PipeTransform {

  transform(phone: IPhoneNumber): string {
    if (!phone || !phone.phoneNumber || !phone.areaCode) { return ''; }
    try {
      return `(${phone.areaCode}) ${phone.phoneNumber.substring(0, 3)}-${phone.phoneNumber.substring(3, phone.phoneNumber.length)}`;
    } catch (e) {
      Logger.log('Ocurrio un error', e?.message);
    }
  }

}
